<template>
  <section class="application-header">

    <!-- 面包屑 -->
    <div class="bread">
      <router-link class="bread-item" to="/orders">订单管理</router-link>
      <div class="bread-arrow">&gt;</div>
      <router-link class="bread-item" :to="'/orders/ordering/waitting-for-upload/' + orderId">资料上传</router-link>
      <div class="bread-arrow">&gt;</div>
      <router-link class="bread-item" :to="'/orders/ordering/' + orderId + '/apply/' + applicantId">申请表详情</router-link>
    </div>

    <!-- 静态的header -->
    <div class="static-header">

      <!-- 返回 -->
      <div class="back-btn" @click="leaveFillApplication">
        <img src="../../../assets/imgs/application/arrow-back.png">
        <span>返回</span>
      </div>

      <!-- 名字和身份 -->
      <div class="name-and-identity">
        <div class="name">{{applicant.applicant_name}}</div>
        <div class="identity">{{applicant.identity}}</div>
      </div>
      <!-- 提交 -->
      <el-button type="primary" class="submit-application-form" @click="submitApplicationForm" :disabled="submitBtnDisabled">提交申请表</el-button>
    </div>

    <!-- 固定的header -->
    <div class="fixed-header" v-show="fixedHeader">

      <div class="fixed-header-inner">
        <!-- 返回 -->
        <div class="back-btn" @click="leaveFillApplication">
          <img src="../../../assets/imgs/application/arrow-back.png">
          <span>返回</span>
        </div>

        <!-- 名字和身份 -->
        <div class="name-and-identity">
          <div class="name">{{applicant.applicant_name}}</div>
          <div class="identity">{{applicant.identity}}</div>
        </div>

        <!-- 提交 -->
        <el-button type="primary" class="submit-application-form" @click="submitApplicationForm" :disabled="submitBtnDisabled">提交申请表</el-button>
      </div>
    </div>
  </section>
</template>

<script>
import _ from 'lodash';
import applicantConstants from '../../../constants/applicant-constants';

export default {
  name: 'application-header',
  components: {
  },
  props: {

    // 订单
    order: {
      type: Object,
      default() {
        return {};
      },
    },

    // 订单编号
    orderId: {
      type: Number,
      required: true,
      default: 0,
    },

    //  申请人编号
    applicantId: {
      type: Number,
      required: true,
      default: 0,
    },

    // 申请人信息
    applicant: {
      type: Object,
      required: true,
      default: () => ({}),
    },

    // 提交中
    submitting: {
      type: Boolean,
      required: true,
      default: false,
    },

    // 申请表组的状态
    applicationGroupStatus: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  computed: {
    submitBtnDisabled() {
      if (this.submitting) {
        return true;
      }

      // 这个一定有数据，如果没有就禁用
      if (_.isEmpty(this.applicationGroupStatus)) {
        return true;
      }

      // 简单说就是剩下最后一组没有完成或者都完成了，才可以点
      const keys = Object.keys(this.applicationGroupStatus);
      let finishedGroupCount = 0;
      keys.forEach((key) => {
        if (this.applicationGroupStatus[key] === applicantConstants.APPLICATION_GROUP_STATUS.valid) {
          finishedGroupCount += 1;
        }
      });
      const unfinishedGroupCount = keys.length - finishedGroupCount;
      return unfinishedGroupCount > 1;
    },
  },
  data() {
    return {
      fixedHeader: false,
    };
  },
  methods: {

    // 离开申请表填写页面
    leaveFillApplication() {
      this.$emit('leave');
    },

    // 提交表单
    submitApplicationForm() {
      this.$emit('formSubmitted');
    },

    fixHeaderHandler() {
      this.fixedHeader = window.scrollY > 100;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.fixHeaderHandler);
  },
  destroyed() {
    window.removeEventListener('scroll', this.fixHeaderHandler);
  },
};
</script>

<style lang="less" scoped>
@import  '../../../assets/less/variable';
section.application-header {
  div.static-header,
  div.fixed-header {
    width: 100%;
    height: 65px;
    background-color: @lightGray;
    display: flex;
    align-items: center;
    padding: 0 30px 0 20px;
    box-shadow: 1px 0px 4px 0px rgba(0, 0, 0, 0.1);
    div.back-btn {
      cursor: pointer;
      display: flex;
      align-items: center;
      &:hover {
        opacity: .8;
      }
      img {
        width: 8px;
        height: 14px;
        margin-right: 10px;
      }
      span {
        font-size: 14px;
        color: @main;
      }
    }
    div.name-and-identity {
      flex: 1;
      display: flex;
      align-items: center;
      margin-left: 40px;
      div.name {
        font-size: 18px;
        color: @text-dark;
        font-weight: 600;
        margin-right: 30px;
      }
      div.identity {
        font-size: 14px;
        color: @text-sliver;
      }
    }
    .application-form-share {
      font-size: 14px;
      margin-right: 20px;
    }
    button.submit-application-form {
      width: 134px;
      height: 34px;
      padding: 0;
    }
  }
  div.fixed-header {
    position: fixed;
    z-index: 100;
    left: 0;
    top: 0;
    background-color: white;
    padding: 0;
    div.fixed-header-inner {
      width: 1000px;
      height: 60px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      padding: 0 30px 0 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/application/components/application-header.vue